import axios from 'axios';

export const STAFF_API = process.env.REACT_APP_CORE_API || 'https://v-room.app';

export function getDeviceId() {
  let value = localStorage.getItem('vroomStaffDeviceId');
  if (!value) {
    value = globalThis.crypto?.randomUUID?.() || `web-${Date.now()}-${Math.random().toString(36).slice(2)}`;
    localStorage.setItem('vroomStaffDeviceId', value);
  }
  return value;
}

export function installStaffInterceptors(tokenKey = 'adminToken') {
  if (axios.__vroomStaffInstalled) return;
  axios.__vroomStaffInstalled = true;
  let refreshPromise = null;
  axios.interceptors.request.use((config) => {
    const token = localStorage.getItem(tokenKey);
    if (token && !config.headers?.Authorization) config.headers.Authorization = `Bearer ${token}`;
    config.headers = { ...(config.headers || {}), 'x-device-id': getDeviceId() };
    if (String(config.url || '').startsWith(STAFF_API)) config.withCredentials = true;
    return config;
  });
  axios.interceptors.response.use((response) => response, async (error) => {
    const original = error.config;
    if (error.response?.status !== 401 || original?._staffRetry || String(original?.url || '').includes('/api/staff/auth/')) throw error;
    original._staffRetry = true;
    refreshPromise ||= axios.post(`${STAFF_API}/api/staff/auth/refresh`, {}, { withCredentials: true, _staffRetry: true })
      .then(({ data }) => { localStorage.setItem(tokenKey, data.accessToken); return data.accessToken; })
      .finally(() => { refreshPromise = null; });
    try {
      const token = await refreshPromise;
      original.headers = { ...(original.headers || {}), Authorization: `Bearer ${token}` };
      return axios(original);
    } catch (refreshError) {
      localStorage.removeItem(tokenKey);
      if (window.location.pathname !== '/login') window.location.assign('/login');
      throw refreshError;
    }
  });
}
